<!-- Trigger field -->
<div cdkOverlayOrigin #triggerOrigin="cdkOverlayOrigin" class="trigger-wrapper" (click)="openDropdown()">
  <mat-form-field floatLabel="always" class="trigger-field">
    <input
      matInput
      readonly
      [value]="selectionDisplayText"
      [placeholder]="placeholder"
    />
  </mat-form-field>
</div>

<!-- Dropdown overlay panel -->
<ng-template
  cdkConnectedOverlay
  [cdkConnectedOverlayOrigin]="triggerOrigin"
  [cdkConnectedOverlayOpen]="isOpen"
  [cdkConnectedOverlayHasBackdrop]="true"
  [cdkConnectedOverlayWidth]="dropdownWidth"
  [cdkConnectedOverlayOffsetY]="-22"
  cdkConnectedOverlayBackdropClass="cdk-overlay-transparent-backdrop"
  (backdropClick)="cancelSelection()"
>
  <div class="dropdown-panel">
    <!-- Search input -->
    <lib-common-ui-components-text-input
      floatLabel="always"
      placeholder="Type to filter..."
      label="Search OUs & collections"
      class="search-input"
      iconPrefix="search"
      [value]="searchText"
      (input)="onInputChange($event)"
    ></lib-common-ui-components-text-input>

    <!-- Scrollable content area -->
    <div class="picker-scroll-area">
      <!-- OU Tree Section -->
      <div class="section">
        <div class="section-header" (click)="toggleOuSection()">
          <mat-icon class="section-toggle-icon">{{ ouSectionExpanded ? 'expand_less' : 'expand_more' }}</mat-icon>
          <span>Organizational Units</span>
        </div>
        <div *ngIf="ouSectionExpanded">
          <lib-cdw-tree
            [multiSelect]="multiSelect"
            [progressiveParentSelect]="progressiveParentSelect"
            [filterValue]="filterValue"
            [dataSource]="ouTreeData"
            [selectable]="true"
            [treeHeight]="dynamicTreeHeight"
            [formControl]="treeControl"
            (selectedNodeChanged)="onOuSelectionChanged($event)"
            (renderedNodeCountChanged)="onRenderedNodeCountChanged($event)"
          ></lib-cdw-tree>
        </div>
      </div>

      <!-- OU Collections Section -->
      <div class="section">
        <div class="section-header" (click)="toggleCollectionsSection()">
          <mat-icon class="section-toggle-icon">{{ collectionsSectionExpanded ? 'expand_less' : 'expand_more' }}</mat-icon>
          <span>OU Collections</span>
        </div>
        <div class="collection-list" *ngIf="collectionsSectionExpanded && filteredCollections.length > 0">
          <!-- Multi-select mode: use checkboxes -->
          <div class="collection-item" *ngFor="let collection of filteredCollections" [class.single-select-mode]="!multiSelect" (click)="multiSelect ? null : onCollectionRadioChange(collection)">
            <lib-cdw-checkbox
              *ngIf="multiSelect"
              [value]="collection"
              [checked]="isCollectionSelected(collection)"
              (checkedEmitter)="onCollectionCheckboxChange($event)"
            ></lib-cdw-checkbox>
            <!-- Single-select mode: use radio buttons -->
            <lib-cdw-radio-button
              *ngIf="!multiSelect"
              [value]="collection.id"
              [checked]="isCollectionSelected(collection)"
              name="ouCollectionRadio"
            ></lib-cdw-radio-button>
            <span class="collection-name">{{ collection.name }}</span>
          </div>
        </div>
      </div>
    </div>

    <!-- Footer actions -->
    <div class="dropdown-actions">
      <lib-cdw-button level="primary" mode="small" (buttonClick)="applySelection()">Done</lib-cdw-button>
    </div>
  </div>
</ng-template>
